import { func, string } from 'prop-types';
import React from 'react';

import { colors } from 'styles/provider';

const NeurologistText = ({ text = '' }, { fmString }) => {
  return (
    <div>
      <h3>{fmString('onlineRehabilitation.neurologistFeedback')}</h3>
      <br />
      <div
        style={{
          whiteSpace: 'pre-line',
          color: colors.clrDarkGray,
          backgroundColor: colors.clrHeatMap2 + '22',
          padding: '2.5rem',
        }}
      >
        {text}
      </div>
    </div>
  );
};

NeurologistText.propTypes = {
  text: string,
};
NeurologistText.contextTypes = {
  fmString: func,
};

export default NeurologistText;
